import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './snap-and-sell-ad-page.component.html',
  styleUrls: ['./snap-and-sell-ad-page.component.scss']
})
export class SnapAndSellAdPageComponent extends MaterialPage {

  constructor(
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    router: Router,
    sidenavService: SidenavService
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:Snap&Sell`, 
      $localize `:page description:Tired of filling in long forms when selling secondhand things? Try our Snap&Sell feature to create listings in an instant.`, 
      true);
  }
}
